import { Component, OnDestroy, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import moment from 'moment-timezone';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { SharedService } from '../shared.service';
import { localStorageService } from '../localstorage.service';
import { ApiService } from '../api.service';
import { MainService } from '../main.service';
import { ActivatedRoute } from '@angular/router';
import { event } from 'jquery';

@Component({
  selector: 'app-add-edit-training',
  templateUrl: './add-edit-training.component.html',
  styleUrls: ['./add-edit-training.component.scss'],
  providers: [DatePipe]
})
export class AddEditTrainingComponent implements OnInit,OnDestroy {

  public data: any;
  public trainingSwitch: any = false;
  pastTrainingTime: any = {};
  selectedTimezone: any = null;
  timezones: any = [];
  timezoneArray: any = [];

  eventId: any = null;
  viewType: any = null;
  minTimeGap: any = null;
  searchDoctorTimeOutRef: any = null;

  // Scroll pagination of the Business / Partner name dropdown. Pages are appended to selectedAppt.doctors,
  // so scrolling back up never re-requests a page that was already loaded.
  readonly doctorPageLimit = 20;
  doctorSearchString = '';
  doctorNextOffset = 0;
  doctorHasMore = false;
  doctorPageLoading = false;
  private doctorSearchRequest: Subscription | null = null;
  // Disabled placeholder rows shown at the bottom of the dropdown while a page loads, in place of the
  // global overlay loader. Both id fields are set so the same rows work for the doctor and partner lists.
  private readonly doctorSkeletonRows: any[] = [-1, -2, -3].map((id: number) => ({
    doctor_id: id, partner_id: id, doctor_name: '', partner_name: '', disabled: true, isSkeleton: true
  }));
  private doctorItemsSource: any[] | null = null;
  private doctorItemsWithSkeleton: any[] = [];

  // Items for the Business / Partner dropdown. The list is memoised per source array: ngx-select resets
  // whenever [items] gets a new reference, so a fresh array on every change detection would break it.
  get doctorDropdownItems(): any[] {
    const doctors = this.selectedAppt && this.selectedAppt.doctors;
    if (!doctors || !this.doctorPageLoading) {
      return doctors;
    }
    if (this.doctorItemsSource !== doctors) {
      this.doctorItemsSource = doctors;
      this.doctorItemsWithSkeleton = [...doctors, ...this.doctorSkeletonRows];
    }
    return this.doctorItemsWithSkeleton;
  }

  // ngx-select's default filter matches the typed text against the option text, which would hide the
  // skeleton rows (they have none).
  doctorSearchCallback = (search: string, option: any): boolean =>
    !!(option.data && option.data.isSkeleton) || !search || String(option.text ?? '').toLowerCase().includes(search.toLowerCase());

  // Back to the first page with nothing pending, so the next open of the modal starts fresh.
  resetDoctorPagination() {
    if (this.searchDoctorTimeOutRef) {
      clearTimeout(this.searchDoctorTimeOutRef);
      this.searchDoctorTimeOutRef = null;
    }
    if (this.doctorSearchRequest) {
      this.doctorSearchRequest.unsubscribe();
      this.doctorSearchRequest = null;
    }
    this.doctorSearchString = '';
    this.doctorNextOffset = 0;
    this.doctorHasMore = false;
    this.doctorPageLoading = false;
    this.doctorItemsSource = null;
  }
  private doctorDropdownScrollListener = (event: Event) => this.onDoctorDropdownScroll(event);

  current_zone_name: any = '';
  timezone: any = '';
  currentUtcOffset: any = moment().utcOffset();

  selectedAppt: any = null;
  trainingDurations: any = [15, 30, 45, 60];

  trainingStatusTypes: any = [];
  eventToken = Math.random();
  trainingStatus: any;
  dateConfig: any = {
    containerClass: 'theme-blue',
    placement: 'left',
    dateInputFormat: 'MM-DD-YYYY'
  };
  today: Date = new Date();
  subscription!: Subscription;
  routeSubscription!: Subscription;
  hours = [{ value: "00" }, { value: "01" }, { value: "02" }, { value: "03" }, { value: "04" }, { value: "05" }, { value: "06" }, { value: "07" }, { value: "08" }, { value: "09" }, { value: "10" }, { value: "11" }, { value: "12" }, { value: "13" }, { value: "14" }, { value: "15" }, { value: "16" }, { value: "17" }, { value: "18" }, { value: "19" }, { value: "20" }, { value: "21" }, { value: "22" }, { value: "23" }];
  minutes = [{ value: "00" }, { value: "15" }, { value: "30" }, { value: "45" }];
  mobile_code_arr: any;
  selectedMobileCode: any;
  country_id: any;
  timezoneName!: string;

  editableUserName = '';
  editableUserEmail = '';
  editableUserPhone = '';
  editableUserWebsite = '';

  phonePattern = /^\+1-\d{10}$/;

  emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  allEventData: any;

  // training booked from the business panel by a business user (agent) rather than by the business owner
  get bookedByAgent(): boolean {
    return !!(this.allEventData && parseInt(this.allEventData.training_agent_id) > 0);
  }
  isWebsiteValid: boolean =true;
  send: number = 1;
  showChangeAssigneeModal: any = false;
  changeAssigneeAdmin: any[] = [];

  attachmentImages: any[] = [];
  existingDocs: any[] = [];
  attachmentUploading: boolean = false;
  @ViewChild('trainingAttachmentInput') trainingAttachmentInputRef!: ElementRef;
  // Bound to the Follow Up p-calendar's [minDate]. Must be a stable object reference -- calling a function
  // like getMinDate() directly in the template creates a brand new Date on every change-detection cycle,
  // which makes PrimeNG's Calendar treat minDate as constantly changing and can prevent a selected value from
  // sticking/displaying at all.
  followupMinDate: Date = new Date();

  // Follow Up (4/9) and No Show (6) show the same calendar widget, but must keep independent values -- this
  // reads/writes whichever of selectedAppt.followUpFollowupDate / noShowFollowupDate applies to the currently
  // selected status, and mirrors the result into selectedAppt.followup_date (the single field addUpdateTraining()
  // actually sends to the backend on Save).
  get displayedFollowupDate(): Date | null {
    if (!this.selectedAppt) {
      return null;
    }
    return parseInt(this.selectedAppt.status) === 6
      ? (this.selectedAppt.noShowFollowupDate || null)
      : (this.selectedAppt.followUpFollowupDate || null);
  }
  set displayedFollowupDate(value: Date | null) {
    if (!this.selectedAppt) {
      return;
    }
    if (parseInt(this.selectedAppt.status) === 6) {
      this.selectedAppt.noShowFollowupDate = value;
    } else {
      this.selectedAppt.followUpFollowupDate = value;
    }
    this.selectedAppt.followup_date = value;
  }

  constructor(
    public mainService: MainService,
    public bsModalRef: BsModalRef,
    public datePipe: DatePipe,
    public _shared: SharedService,
    private _local: localStorageService,
    private _api: ApiService,
    private _sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    // scroll events don't bubble, so listen in the capture phase to catch the dropdown's own scrolling
    this.ngZone.runOutsideAngular(() => {
      this.elementRef.nativeElement.addEventListener('scroll', this.doctorDropdownScrollListener, true);
    });
    this.today.setHours(0, 0, 0, 0);
    this.currentUtcOffset = this.getSelectedTimezoneOffset();
    this.selectedTimezone = this.data.selectedTimezone;
    //this.timezones = this.data.timezones;
    this.viewType = this.data.viewType;
    this.minTimeGap = this.data.minTimeGap;
    this.eventToken = this.data.eventToken ? this.data.eventToken : this.eventToken;
    this.trainingStatus = this.data.trainingStatus ? this.data.trainingStatus : null;
    this.country_id = this.data && this.data.country_id ? this.data.country_id : this.country_id;
    if (this.data.doctor_id) {
      this.selectedAppt = { selectedDoctor: {
        doctor_name: this.data.doctor_name,
        doctor_emails: this.data.doctor_email,
        doctor_mobile: this.data.doctor_mobile,
        doctor_mobile_country_code: this.data.doctor_mobile_country_code,
        doctor_id: this.data.doctor_id,
        practice_name: this.data.practice_name
      }, out_of_system: false, timezone: this.selectedTimezone || this.timezone }
    }else {
      this.selectedAppt = { selectedDoctor: null, out_of_system: false }
    }
    this.showChangeAssigneeModal = this.viewType === 'changeAssignee' ? true : false;
    /*this.mainService.getTimezone()
    .subscribe((data: any) => {
      this.timezoneArray = data;
    });*/
    this.subscription = this._shared.timezone$
      .subscribe((response: any) => {
        this.current_zone_name = this._shared.timezoneName;
        this.timezone = this._shared.timezone;
        const data = this._shared.getTimezoneList();
        this.timezones = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i].val) {
            var tzOffset = (parseInt(data[i].val.substring(0, data[i].val.length - 2)) * 60) + parseInt(data[i].val.substring(data[i].val.length - 2));
            var timezoneHours = parseInt((parseInt((tzOffset + "")) / 60) + "");
            timezoneHours = timezoneHours < 0 ? (-1 * timezoneHours) : timezoneHours;
            var timezoneMinutes = (tzOffset % 60);
            timezoneMinutes = timezoneMinutes < 0 ? (-1 * timezoneMinutes) : timezoneMinutes;
            var timezoneString = (tzOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0" : "") + timezoneHours + ":" + (timezoneMinutes < 10 ? "0" : "") + timezoneMinutes;

            this.timezones.push({
              code: data[i].offset,
              name: data[i].name,
              tzOffset: tzOffset,
              timezoneString: timezoneString,
              country_id: data[i].country_id,
              val: data[i].val,
              offset: data[i].offset,
              zone: data[i].zone,
            });
          }
          if (i === data.length - 1) {
            this.timezoneName = this.timezones && this.timezones.find((id: any) => id.val == this.timezone)?.code;
            this.current_zone_name = this.timezoneName
            console.log(this.timezoneName);
          }
        }
        
      });
      this.routeSubscription = this.route.queryParams.subscribe((params: any) => {
        this.timezone = params['timezone'];
        // this.timezones = this._shared.getTimezoneList();
        this.timezoneName = this.timezones && this.timezones.find((id: any) => id.val == this.timezone)?.offset;
        this.current_zone_name = this.timezoneName;
        console.log('test', this.timezoneName);
        if (this.viewType === "newTraining") {
          this.showNewTrainingModal();
        }
        else {
          this.eventId = this.data.eventId;
          this.showViewTrainingModal();
        }
        // if (this.id) {
        //   this.getTrainingDetails(this.id);
        // }
      });
  
    this.mainService.mobile_code_arr$.subscribe(data => {
      if (data && data.length) {
        this.mobile_code_arr = data;
        this.selectedMobileCode = this.mobile_code_arr[0];
      };
    });
    // if (this.data && this.data.timezones) {
    //   this.timezones = this.data.timezones;
    // }

  

  }

  getSelectedTimezoneOffset() {
    return (parseInt(this.timezone.substring(0, this.timezone.length - 2)) * 60) + parseInt(this.timezone.substring(this.timezone.length - 2))
  }


  showNewTrainingModal() {
    let timeZone = '';
    if ((this.selectedTimezone + '').includes('****')) {
      timeZone = this.data.timezones.find((id:any) => (id.code + '****' + id.tzOffset) == this.selectedTimezone)?.code+'****'+this.data.timezones.find((id:any) => (id.code + '****' + id.tzOffset) == this.selectedTimezone)?.tzOffset
    } else {
      timeZone = this.data.timezones.find((id:any) => id.val == this.selectedTimezone)?.offset+'****'+this.data.timezones.find((id:any) => id.val == this.selectedTimezone)?.val
    }
    this.selectedAppt = {
      ...this.selectedAppt,
      isDoctorPrefilled: false,
      viewType: "newTraining",
      date: moment().toDate(),
      trainingTypes: [],
      selectedTraining: null,
      trainingDuration: null,
      timezone: timeZone,
      timezones: [],
      selectedAdmin: null,
      selectedAdminId: null,
      adminUsers: [],
      availableAdminUsers: [],
      availableStartTimes: [],
      availableTimeSlots: [],
      // selectedDoctor: null,
      selectedDoctorId: null,
      doctors: [],
      selectedAvailableStartTime: null,
      // out_of_system: false,
      assign_automatic: false,
      send_email: true,
      trainingMeetingLink: '',
      training_doctor_partner_type: 'doctor',
      followup_date: '',
      // 'business' books for the business owner (existing flow), 'business_user' for one or more of
      // its registered users in the same session
      book_for: 'business',
      selectedAgentIds: [],
      originalAgentIds: [],
      businessUsers: [],
      agentDetails: []
    }
    if (this.data.doctor_partner_id) {
      var selectedDoctorId = parseInt(this.data.doctor_partner_id);
      if (this.data.doctor_partner_type == 'partner') {
        let data = {

          partner_id: selectedDoctorId,
          timezone_offset: this.getSelectedTimezoneOffset(),
        };
        this._api.api(data, 'partner_info_v2')
          .subscribe((data: any) => {
            if (data.partner_profile[0].partner_id == null) {
              this.getTrainingTypes();
            } else {
              var partnerData = data.partner_profile[0];
              console.log(partnerData);
              this.selectedAppt.selectedDoctorId = selectedDoctorId;
              var selectedDoctor = {
                partner_name: partnerData.partner_name,
                partner_email: partnerData.partner_email,
                partner_mobile: partnerData.partner_mobile,
                doctor_name: partnerData.partner_name,
                doctor_mobile: partnerData.partner_mobile ? partnerData.partner_mobile : '-',
                doctor_emails: partnerData.partner_email ? partnerData.partner_email : '-',
              }
              if (partnerData.partner_mobile_country_code) {
                this.selectedMobileCode = partnerData.partner_mobile_country_code;
              }
              this.selectedAppt.doctors = [selectedDoctor];
              this.selectedAppt.doctors[0].partner_id = selectedDoctorId;
              this.selectedAppt.selectedDoctor = selectedDoctor;
              this.selectedAppt.out_of_system = false;
              this.getTrainingTypes();
              this.selectedAppt.training_doctor_partner_type = 'partner'
            }
          });
      } else {
        let data = {

          doctor_id: selectedDoctorId,
          timezone_offset: this.getSelectedTimezoneOffset(),
        };
        this._api.api(data, 'business/doctor_info', 'get')
          .subscribe((data: any) => {
            if (data.doctor_profile[0].doctor_id == null) {
              this.getTrainingTypes();
            } else {
              var doctorData = data.doctor_profile[0];
              this.selectedAppt.selectedDoctorId = selectedDoctorId;
              var selectedDoctor = {
                doctor_id: this.selectedAppt.selectedDoctorId,
                practice_name: doctorData.practice_name ? doctorData.practice_name : '-',
                doctor_name: doctorData.doctor_name,
                //doctor_first_name: eventData.doctor_first_name,
                //doctor_last_name: eventData.doctor_last_name,
                doctor_mobile: doctorData.doctor_mobile ? doctorData.doctor_mobile : '',
                doctor_emails: doctorData.doctor_email ? doctorData.doctor_email : '-',
              }

              if (doctorData.doctor_mobile_country_code) {
                this.selectedMobileCode = doctorData.doctor_mobile_country_code;
              }
              this.selectedAppt.doctors = [selectedDoctor];
              this.selectedAppt.selectedDoctor = selectedDoctor;
              this.selectedAppt.isDoctorPrefilled = !!(selectedDoctor.doctor_name && selectedDoctor.doctor_mobile);
              this.selectedAppt.out_of_system = false;
              this.getTrainingTypes();
            }
          });
      }
    } else {
      this.getTrainingTypes();
    }
  };


  getMinDate() {
    return moment().toDate();
  }
  getPastMinDate() {
    return moment().toDate();
  }


  showViewTrainingModal() {
    // tslint:disable:max-line-length
    // tslint:disable:comment-format
    //admin_id: this.viewType === "allTimePref" ? this.calType === "single_day_view" ? this.adminUsers[parseInt(col)].admin_id : this.selectedAdmin : this.selectedAdmin,
    /*var selectorDict = this.cloneObj(this.timeSlotSelectorsDict[selectorId]);
    if(selectorDict["type"] === "doctor_partner_training")
    {

    }*/
    //var startCol = parseInt(selectorDict["startDay"]);
    var event_id = parseInt(this.eventId);

    //var admin_id = this.viewType === "allTimePref" ? this.calType === "single_day_view" ? this.adminUsers[parseInt(startCol+"")].admin_id : this.selectedAdmin : this.selectedAdmin;

    var thisRef = this;
    let reqData = {
      event_id: event_id,
    };
    this._api.api(reqData, 'scheduler/get_event_details', 'get').subscribe((data: any) => {
      if (!data.is_error) {
        this.allEventData= data.eventData
        console.log(this.allEventData,"training_doctor_name");

        var eventData = data.eventData;
        this.existingDocs = (eventData.attachments || []).slice();
        this.attachmentImages = [];
        console.log(eventData);
        var selectedUtcOffset = thisRef.selectedTimezone ? parseInt(thisRef.selectedTimezone.split("****")[1]) : thisRef.currentUtcOffset;
        var applicableOffset = thisRef.getApplicableOffsetBasedOnDaylight(eventData.training_timezone_short_name, eventData.training_timezone_offset);
        const filterItem = this.timezones.find((item: any) => item.offset === this.timezoneName);
        // console.log(filterItem?.zone);
        let schedule_date, schedule_time;
        if (filterItem && eventData.training_timezone_short_name != filterItem.offset){
          schedule_date = moment(parseInt(eventData.training_start_timestamp)*1000).utcOffset(applicableOffset).format("MM/DD/YYYY");
          schedule_time = moment(parseInt(eventData.training_start_timestamp) * 1000).utcOffset(applicableOffset).format("hh:mm A");

          // schedule_time = moment(eventData.followup_date).tz(filterItem?.zone).format('hh:mm A')
          console.log(filterItem?.zone,"filterItem?.zone");
          
        }else {
          schedule_date = moment(parseInt(eventData.training_start_timestamp)*1000).utcOffset(applicableOffset).format("MM/DD/YYYY");
          schedule_time = moment(parseInt(eventData.training_start_timestamp) * 1000).utcOffset(applicableOffset).format("hh:mm A");
        }
    
        var training_type = parseInt(eventData.doctor_partner_training_type);
        var admin_id = eventData.training_admin_id;
        var adminObj = {
          admin_name: eventData.admin_name,
          admin_email: eventData.admin_email,
        };
        var selectedDoctorId = parseInt(eventData.training_doctor_partner_id);
        var out_of_system = selectedDoctorId ? false : true;
        var selectedDoctor = {
          practice_name: eventData.training_practice_name,
          doctor_name: eventData.training_doctor_partner_name,
          //doctor_first_name: eventData.doctor_first_name,
          //doctor_last_name: eventData.doctor_last_name,
          practice_mobile: eventData.training_doctor_partner_phone ? eventData.training_doctor_partner_phone : "",
          doctor_emails: eventData.training_trainee_emails ? eventData.training_trainee_emails : eventData.doctor_email,
          partner_name: eventData.partner_name,
          partner_email: eventData.partner_email,
          partner_mobile: eventData.partner_mobile
        }
    
    
        thisRef.selectedAppt = {
          viewType: thisRef.viewType,
          //date: moment(schedule_date).toDate(),
          date: moment().toDate(),
          trainingTypes: [],
          selectedTraining: training_type,
          trainingDuration: null,
          training_start_timestamp: eventData.training_start_timestamp,
          training_duration: parseInt(((eventData.training_end_timestamp - eventData.training_start_timestamp) / 60) + ""),
          training_timezone_short_name: eventData.training_timezone_short_name,
          training_timezone_offset: eventData.training_timezone_offset,
          schedule_date: schedule_date,
          schedule_time: schedule_time,
          timezone: this.timezones.find((id:any) => id.val == this.timezone)?.code+'****'+this.timezones.find((id:any) => id.val == this.timezone)?.tzOffset,
          //timezones: thisRef.timezones,
          eventId: event_id,
          excludeAdminId: admin_id,
          excludeAdmin: adminObj,
          selectedTrainingObj: null,
          selectedAdminId: null,
          selectedAdmin: null,
          adminUsers: [],
          availableAdminUsers: [],
          availableStartTimes: [],
          //trainingNote: (thisRef.viewType === "updateTrainingStatus" || thisRef.viewType === "updateTrainingNotes")  ? "" : eventData.training_event_desc,
          trainingNote: "",
          trainingMeetingLink: eventData.training_meeting_link,
          availableTimeSlots: [],
          selectedDoctor: selectedDoctor,
          selectedDoctorId: selectedDoctorId,
          doctors: [],
          //status: thisRef.viewType === "rescheduleTraining" ? "3" : eventData.training_status+"",
          status: thisRef.trainingStatus ? thisRef.trainingStatus + "" : eventData.training_status + "",
          training_status_name: eventData.training_status_name,
          old_status: eventData.training_status + "",
          selectedAvailableStartTime: null,
          out_of_system: out_of_system,
          assign_automatic: false,
          send_email: true,
          training_doctor_partner_type: eventData.training_doctor_partner_type,
          training_doctor_partner_id: eventData.training_doctor_partner_id,
          training_source: eventData.training_source,
          followup_date: eventData.followup_date? moment.utc(eventData.followup_date).tz(filterItem?.zone).toDate() : null,
          // Follow Up (4/9) and No Show (6) share one visible date/time field, but must not overwrite each
          // other's value -- seed both from whatever the training already has; from here on the
          // displayedFollowupDate getter/setter keeps them independent per status.
          followUpFollowupDate: eventData.followup_date? moment.utc(eventData.followup_date).tz(filterItem?.zone).toDate() : null,
          noShowFollowupDate: eventData.followup_date? moment.utc(eventData.followup_date).tz(filterItem?.zone).toDate() : null}


        if (thisRef.selectedAppt) {
          // Booked by a business user (agent): the agent IS the training user, so these inputs edit the
          // agent's own details (training_agent_*). training_doctor_* is the business owner's override
          // and applies only to an owner-booked training -- reading it here is what made the modal
          // prefill, and then save, the business's details for a business user's training.
          const agentBooking = parseInt(eventData.training_agent_id) > 0;
          this.editableUserName   = agentBooking ? (eventData.training_agent_name || '') : (eventData.training_doctor_name ? eventData.training_doctor_name : eventData.doctor_name ? eventData.doctor_name: thisRef.selectedAppt.selectedDoctor.doctor_name || '');
          this.editableUserEmail  = agentBooking ? (eventData.training_agent_email || '') : (eventData.training_doctor_email ? eventData.training_doctor_email : eventData.doctor_email ? eventData.doctor_email : thisRef.selectedAppt.selectedDoctor.doctor_emails || '');
          // A business user with no number of their own is prefilled with the business owner's, but an
          // edit still saves to the business user (training_agent_phone), never to the owner.
          this.editableUserPhone  = agentBooking ? (eventData.training_agent_phone || (eventData.doctor_mobile ? `+1-${eventData.doctor_mobile}` : '')) :(eventData.training_doctor_phone ? eventData.training_doctor_phone : (eventData.doctor_mobile ? `+1-${eventData.doctor_mobile}` : thisRef.selectedAppt.selectedDoctor.practice_mobile || ''));
          this.editableUserWebsite = eventData.training_doctor_website_link || '';

          // A business-user training can have several users: the form lists them (add / remove) and gives
          // each their own Name / Email / Contact for this training instead of the single inputs above.
          thisRef.selectedAppt.book_for = agentBooking && eventData.training_doctor_partner_type === 'doctor' ? 'business_user' : 'business';
          thisRef.selectedAppt.businessUsers = [];
          thisRef.selectedAppt.selectedAgentIds = [];
          thisRef.selectedAppt.originalAgentIds = [];
          thisRef.selectedAppt.agentDetails = [];
          if (thisRef.selectedAppt.book_for === 'business_user') {
            const trainingAgents = (eventData.training_agents || []).length ? eventData.training_agents : [{
              agent_id: eventData.training_agent_id,
              training_agent_name: eventData.training_agent_name,
              training_agent_email: eventData.training_agent_email,
              training_agent_phone: eventData.training_agent_phone
            }];
            thisRef.selectedAppt.selectedAgentIds = trainingAgents.map((agent: any) => Number(agent.agent_id));
            thisRef.selectedAppt.originalAgentIds = [...thisRef.selectedAppt.selectedAgentIds];
            thisRef.selectedAppt.agentDetails = trainingAgents.map((agent: any) =>
              thisRef.agentRow(agent.agent_id, agent.training_agent_name, agent.training_agent_email, agent.training_agent_phone));
            thisRef.fetchBusinessUsers(eventData.training_doctor_partner_id, true, trainingAgents);
          }
        }
        if (this.viewType === 'changeAssignee') {
          thisRef.selectedAppt.date = this.data.startDate;
        }
        //thisRef.apptModal.show();
        //thisRef.isProcessing = false;
        thisRef.setViewType();
        thisRef.getTrainingTypes();
      }
    })
    // this.fetchEventDetailsApi(event_id, function (err: any, data: any) {
    //   if (!err) {
    //   }
    //   else {
    //     //thisRef.isProcessing = false;
    //     //showLoadingWithMessage("");
    //     //enableDisableFilters(!isProcessing);
    //   }
    // });
  };

  getApplicableOffsetBasedOnDaylight(tzShortCode: any, tzOffset: any) {
    let selectedUtcOffset = this.getTimezoneOffsetFromString(this.timezone);
    let trainingTzObj = this.timezones.find((tz: any) => tz.offset === tzShortCode);
    if (!trainingTzObj) {
      let alternateTrainingTzObj = this.timezones.find((tz: any) => tz.alternate_daylight_code === tzShortCode);
      if (alternateTrainingTzObj) {
        selectedUtcOffset += (tzOffset - this.getTimezoneOffsetFromString(alternateTrainingTzObj.val));
      }
    }
    return selectedUtcOffset;
  }

  getTimezoneOffsetFromString(timezoneString: any) {
    return (parseInt(timezoneString.substring(0, timezoneString.length - 2)) * 60) + parseInt(timezoneString.substring(timezoneString.length - 2));
  }

  assignAutomaticChanged() {

  }

  fileSelect(event: any) {
    if (this.attachmentImages && this.attachmentImages.length > 10) {
      this._shared.customPopups('Can not upload more than 10 files', 2);
      return false;
    }
    if (event && event.target && event.target.files && event.target.files.length > 0) {
      for (let file of event.target.files) {
        let selectedFile = { file: file };
        if ((selectedFile.file.size / 1024 / 1024) > 10) {
          this._shared.customPopups('File size must be less than 10MB', 2);
          return false;
        }
        if (selectedFile.file.type.indexOf('image/') === 0 || selectedFile.file.type.indexOf('application/') === 0) {
          let index = this.attachmentImages.findIndex((x: any) => x.file.mediaFile.name == selectedFile.file.name);
          const reader = this.readAttachmentFile(selectedFile);
          if (index < 0) {
            this.attachmentImages.push({ file: reader });
            this.uploadAttachmentFile(reader, this.attachmentImages.length - 1);
            if (this.trainingAttachmentInputRef) {
              this.trainingAttachmentInputRef.nativeElement.value = '';
            }
          }
        } else {
          this._shared.customPopups('Please select valid file', 2);
        }
      }
    }
    return;
  }

  readAttachmentFile(file: any) {
    file.mediaFile = file.file;
    file.file = this._sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file.mediaFile));
    return file;
  }

  uploadAttachmentFile(item: any, index: any) {
    this.attachmentUploading = true;
    this.attachmentImages[index].uploading = true;
    const formData = new FormData();
    formData.append('file', item.mediaFile);
    this.attachmentImages[index].uploadSub = this._api.uploadApi(formData, 'assignments/upload_csr_doc', {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event: HttpEvent<any>) => {
        let response = [];
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total) {
            const percentDone = Math.round(100 * event.loaded / event.total);
            response.push({ status: 'progress', message: percentDone });
          }
        }
        if (event.type === HttpEventType.Response) {
          response.push(event.body);
        }
        return response;
      })
    ).subscribe(d => {
      this.attachmentImages[index].subs = d;
      let success = d.every((item: any) => item.status !== 'progress');
      if (success) {
        this.attachmentUploading = false;
        this.attachmentImages[index].uploading = false;
        d.forEach((item: any) => {
          this.attachmentImages[index].image = item.images[0];
        });
      } else {
        this.attachmentUploading = true;
        this.attachmentImages[index].uploading = true;
      }
    });
  }

  cancelAttachmentUpload(index: any) {
    this.attachmentImages[index].uploadSub.unsubscribe();
    this.attachmentImages.splice(index, 1);
    this.attachmentUploading = this.attachmentImages.some((item: any) => item.uploading);
  }

  removeUploadedAttachment(index: any) {
    this.attachmentImages.splice(index, 1);
  }

  removeExistingDoc(index: any) {
    // Attachments are plain {file_url, thumb_url} entries in a JSON array (no row id) -- remove by position
    // and send whatever remains via buildAttachmentsPayload() on save; nothing else to do server-side.
    this.existingDocs.splice(index, 1);
  }

  // Single `attachments` field for the backend instead of two separate ones -- existing (kept) attachments
  // are sent as their {file_url, thumb_url} objects as-is, newly uploaded files as plain URL strings still
  // needing thumbnail processing. The backend tells them apart by item type (see resolveAttachments()).
  buildAttachmentsPayload(): any[] {
    const newUrls = this.attachmentImages && this.attachmentImages.length
      ? this.attachmentImages.filter((f: any) => f.image).map((f: any) => f.image)
      : [];
    return [...this.existingDocs, ...newUrls];
  }

  outOfSystemChanged() {
    if (this.selectedAppt.out_of_system) {
      this.selectedAppt.selectedDoctorId = null;
      this.selectedAppt.selectedDoctor = {
      }
    }
    else {
      this.selectedAppt.selectedDoctorId = null;
      this.selectedAppt.selectedDoctor = null
    }
    this.clearBusinessUsers();
  }

  enableDisableSubmitTrainingButton() {
    let enableButton = false;
  
    const appt = this.selectedAppt;
    const doctor = appt.selectedDoctor;
    // Booking for business users needs at least one of them, and every user's details must be valid.
    const hasBusinessUsers = appt.book_for !== 'business_user' || (appt.selectedAgentIds && appt.selectedAgentIds.length > 0);
    const businessUsersValid = !this.isAgentTrainingEdit || (hasBusinessUsers && this.agentDetailsValid());

    /** ---------- EDIT TRAINING ---------- */
    if (appt.viewType === "editTraining") {
      enableButton = !!(
        doctor &&
        appt.selectedAvailableStartTime &&
        appt.trainingNote &&
        (appt.assign_automatic || appt.selectedAdminId) &&
        businessUsersValid
      );
    }
  
    /** ---------- NEW TRAINING ---------- */
    else if (appt.viewType === "newTraining") {
  
      const shouldValidateDoctorManually =
        appt.out_of_system || !appt.isDoctorPrefilled;
  
      const hasDoctorDetails = shouldValidateDoctorManually
        ? (
            doctor?.doctor_emails &&
            this.isValidEmail(doctor.doctor_emails) &&
            (doctor.practice_name ? doctor.practice_name.length <= 256 : true) &&
            doctor.doctor_name &&
            doctor.doctor_name.length <= 256 &&
            (doctor.doctor_mobile
              ? this.isPhoneNumberValid(doctor.doctor_mobile)
              : true)
          )
        : !!appt.selectedDoctorId || !!doctor;
  
      const hasValidMeetingLink =
        appt.trainingMeetingLink
          ? this.isValidUrl(appt.trainingMeetingLink)
          : true;
  
      if (this.trainingSwitch) {
        enableButton = !!(
          hasDoctorDetails &&
          hasBusinessUsers &&
          hasValidMeetingLink &&
          appt.trainingNote &&
          appt.date &&
          this.pastTrainingTime?.hour &&
          this.pastTrainingTime?.minutes
        );
      } else {
        enableButton = !!(
          hasDoctorDetails &&
          hasBusinessUsers &&
          hasValidMeetingLink &&
          appt.selectedAvailableStartTime &&
          appt.trainingNote &&
          (appt.assign_automatic || appt.selectedAdminId)
        );
      }
    }
  
    /** ---------- UPDATE NOTES ---------- */
    if (
      appt.viewType === "updateTrainingNotes" ||
      appt.viewType === "updateTrainingStatus"
    ) {
      enableButton = !!appt.trainingNote;
    }
  
    /** ---------- UPDATE STATUS ---------- */
    if (appt.viewType === "updateTrainingStatus") {
      // A business-user training edits one row per user (see agentDetails) instead of the single inputs.
      enableButton = this.isAgentTrainingEdit
        ? !!(appt.trainingNote && businessUsersValid)
        : !!(
          appt.trainingNote &&
          this.editableUserEmail &&
          this.emailPattern.test(this.editableUserEmail) &&
          this.editableUserName &&
          this.editableUserPhone &&
          this.phonePattern.test(this.editableUserPhone)
        );
    }
  
    return enableButton;
  }
  

  enableDisableSubmitTrainingButtonOLd() {
    var enableButton = false;
    if (this.selectedAppt.viewType === "editTraining") {
      enableButton = (this.selectedAppt.selectedDoctor && this.selectedAppt.selectedAvailableStartTime && this.selectedAppt.trainingNote && (this.selectedAppt.assign_automatic || this.selectedAppt.selectedAdminId));
    }
    else if (this.selectedAppt.viewType === "newTraining") {
      const shouldValidateDoctorManually =!this.selectedAppt.out_of_system && !this.selectedAppt.isDoctorPrefilled;
      var hasDoctorDetails = (shouldValidateDoctorManually ?
        (this.selectedAppt.selectedDoctor.doctor_emails && this.isValidEmail(this.selectedAppt.selectedDoctor.doctor_emails) &&
          (this.selectedAppt.selectedDoctor.practice_name ? this.selectedAppt.selectedDoctor.practice_name.length <= 256 : true)
          && this.selectedAppt.selectedDoctor.doctor_name && this.selectedAppt.selectedDoctor.doctor_name.length <= 256
          && (this.selectedAppt.selectedDoctor.doctor_mobile ? this.isPhoneNumberValid(this.selectedAppt.selectedDoctor.doctor_mobile) : true)) :
        (this.selectedAppt.selectedDoctorId ? true : false)) && (this.selectedAppt.trainingMeetingLink ? this.isValidUrl(this.selectedAppt.trainingMeetingLink) : true);
      if (this.trainingSwitch) {

        enableButton = (hasDoctorDetails && this.selectedAppt.trainingNote && this.selectedAppt.date && this.pastTrainingTime.hour && this.pastTrainingTime.minutes);
      } else {
        enableButton = (hasDoctorDetails && this.selectedAppt.selectedAvailableStartTime && this.selectedAppt.trainingNote && (this.selectedAppt.assign_automatic || this.selectedAppt.selectedAdminId));
      }
    }
    if (this.selectedAppt.viewType === "updateTrainingNotes" || this.selectedAppt.viewType === "updateTrainingStatus") {
      enableButton = this.selectedAppt.trainingNote ? true : false;
    }
    if (this.selectedAppt.viewType === "updateTrainingStatus") {
      enableButton = this.selectedAppt.trainingNote &&( this.editableUserEmail&& this.emailPattern.test(this.editableUserEmail)) && this.editableUserName && (this.editableUserPhone && this.phonePattern.test(this.editableUserPhone)) ? true : false;
    }
    return enableButton;
  }


  submitTrainingViewTitle() {
    var title = "";
    if (this.selectedAppt.viewType === "editTraining") {
      title = 'Edit Training Details';
    }
    if (this.selectedAppt.viewType === "newTraining") {
      title = 'New Training';
    }
    if (this.selectedAppt.viewType === "updateTrainingNotes") {
      title = 'Add Training Notes';
    }
    if (this.selectedAppt.viewType === "updateTrainingStatus") {
      title = 'Update Training Status';
    }

    return title;
  }

  submitTrainingButtonTitle() {
    var title = "";
    if (this.selectedAppt.viewType === "editTraining") {
      title = 'Re-assign Training';
    }
    if (this.selectedAppt.viewType === "newTraining") {
      title = 'Schedule Training';
    }
    if (this.selectedAppt.viewType === "updateTrainingNotes") {
      title = 'Add Notes';
    }
    if (this.selectedAppt.viewType === "updateTrainingStatus") {
      title = 'Update Status';
    }

    return title;
  }

  hideTrainingModal() {
    this.resetDoctorPagination();
    this.bsModalRef.hide();
    //this.selectedAppt = null;
  }

  trainingStatusChanged() {
    this.followupMinDate = new Date();
    // Re-sync the field actually sent on Save to whichever status-specific value applies now -- the setter
    // above only fires when the calendar itself is touched, not on a plain status-dropdown change.
    this.selectedAppt.followup_date = this.displayedFollowupDate;
    this.setViewType();
    if (parseInt(this.selectedAppt.status) === 3) {
      this.getAvailableSlotsOnAppointmentDate();
    }
    if(this.selectedAppt && (!this.editableUserEmail || !this.editableUserPhone|| !this.editableUserName)){
      this.editableUserName   = this.selectedAppt.selectedDoctor.doctor_name || '';
      this.editableUserEmail  = this.selectedAppt.selectedDoctor.doctor_emails || '';
      this.editableUserPhone  = this.selectedAppt.selectedDoctor.practice_mobile || '';
    }
  }

  setViewType() {
    this.selectedAppt.viewType = (parseInt(this.selectedAppt.status) === 3) ? "editTraining" : "updateTrainingStatus";
    if (this.viewType === 'changeAssignee') {
      this.selectedAppt.viewType = 'changeAssignee';
    }
  }

  getTrainingTypes() {
    let params = {  };
    this._api.api(params, 'scheduler/fetch_training_types', 'get')
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.selectedAppt.trainingTypes = data.data;
          if (this.selectedAppt.selectedTraining === null) {
            this.selectedAppt.selectedTraining = this.selectedAppt.trainingTypes.length ? this.selectedAppt.trainingTypes[0].type_id : null;
          }

          var trainingObj = this.selectedAppt.trainingTypes.find((training: any) => training.type_id + "" === this.selectedAppt.selectedTraining + "");
          this.selectedAppt.selectedTrainingObj = trainingObj;
          this.selectedAppt.trainingDuration = trainingObj ? trainingObj.duration : null;


          var currentTz = this.current_zone_name;
          var currentTzObj: any = this.timezones.find((timezone: any) => timezone.code === currentTz);
          this.current_zone_name = currentTzObj ? currentTzObj.code : this.timezones[0].code;
          this.currentUtcOffset = currentTzObj ? currentTzObj.tzOffset : this.timezones[0].tzOffset;

          this.selectedTimezone = this.selectedTimezone ? this.selectedTimezone : this.current_zone_name + "****" + this.currentUtcOffset;
          // if (this.selectedAppt) {
          //   this.selectedAppt.timezone = this.selectedTimezone;
          // }
          var thisRef = this;
          if (this.viewType === "newTraining") {
            this.getAvailableSlotsOnAppointmentDate();
          }
          else {
            this.fetchTrainingStatusesApi((err: any, trainingStatusesData: any) => {
              thisRef.trainingStatusTypes = trainingStatusesData.data;
              thisRef.getAvailableSlotsOnAppointmentDate();
            });
          }
        }
      }, (error: any) => {
        console.log(error);
      });
  }

  ngOnDestroy() {
    console.log('DESTROYED')
    this.elementRef.nativeElement.removeEventListener('scroll', this.doctorDropdownScrollListener, true);
    this.resetDoctorPagination();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  /*hideModal() {
    this.bsModalRef.hide();
  }*/

  addUpdateTraining() {
    var thisRef = this;
    if (this.attachmentUploading) {
      this._shared.customPopups('Please wait while files are uploading', 2);
      return false;
    }
    if (this.selectedAppt.viewType === "updateTrainingStatus" || this.selectedAppt.viewType === "updateTrainingNotes") {
      var extraData: any = {
        event_token: this.eventToken
      }
      console.log(this.selectedAppt);
      if (this.selectedAppt.status == 4 || this.selectedAppt.status == 5 || this.selectedAppt.status == 6 || this.selectedAppt.status == 8 || this.selectedAppt.status == 9) {
        if (this.selectedAppt.status == 4 && !thisRef.selectedAppt.followup_date) {
          this._shared.customPopups('Please select the follow up date', 2);
          return false;
        }
        extraData['followup_date'] = thisRef.selectedAppt.followup_date ? thisRef.datePipe.transform(thisRef.selectedAppt.followup_date, 'yyyy-MM-dd HH:mm:ss') : null;
      }
      // Business users added / removed, and any user's edited details -- only what actually changed.
      if (this.selectedAppt.viewType === "updateTrainingStatus" && this.isAgentTrainingEdit) {
        if (this.agentIdsChanged()) {
          extraData['agent_ids'] = this.selectedAppt.selectedAgentIds.map(Number);
        }
        const agentDetails = this.changedAgentDetails();
        if (agentDetails.length) {
          extraData['agent_details'] = agentDetails;
        }
      }
      this.updateEventStatusNotesApi(this.selectedAppt.eventId, this.selectedAppt.trainingNote,
        this.selectedAppt.viewType === "updateTrainingStatus" ? this.selectedAppt.status : null,
        this.send, extraData, function (err: any, data: any) {
          if (!err) {
            /*thisRef.viewType = "allTimePref";
            thisRef.calType = "single_day_view";
            thisRef.calWeekOffSetFromCurrentWeek = 0;
            thisRef.singleDayDate = thisRef.selectedAppt.date;
            thisRef.timeSlotSelectorsDict = {};
            thisRef.undoRedoIndex = -1;
            thisRef.timeSlotSelectorsDictUndoRedoArray = [];
            thisRef.refreshWeekDaysAndMonthDates();
            thisRef.createTimeSlotSelectorTable();*/

            var successMsg = "The training was edited successfully";
            thisRef._shared.customPopups(successMsg, 0);

            var excludeAdminId = thisRef.selectedAppt.excludeAdminId ? thisRef.selectedAppt.excludeAdminId : null;
            if (thisRef.bsModalRef && thisRef.bsModalRef.content){
              thisRef.bsModalRef.content.trainingCreated = data;
              thisRef.bsModalRef.content.selectedAppt = thisRef.cloneObj(thisRef.selectedAppt);
              console.log(thisRef.selectedAppt);
              thisRef.bsModalRef.content.selectedAppt.selectedAdminId = excludeAdminId;
            }
            thisRef.hideTrainingModal();
          } else {
            thisRef._shared.customPopups(err, 1);
          }
        });
    } else {
      if (this.trainingSwitch) {
        var selectedUtcOffset = parseInt(this.selectedAppt.timezone.split("****")[1])
        let pastdate = new Date(this.selectedAppt.date);
        let start_time = new Date(pastdate.getFullYear(), pastdate.getMonth(), pastdate.getDate(), this.pastTrainingTime.hour, this.pastTrainingTime.minutes, 0);
        let start_time_timestamp = parseInt(moment(start_time).utc().format("X"));
        var endTimeStamp = start_time_timestamp + (this.selectedAppt.trainingDuration * 60);
        var startDateTime = moment(start_time_timestamp * 1000).utcOffset(selectedUtcOffset).format();
        var endDateTime = moment(endTimeStamp * 1000).utcOffset(selectedUtcOffset).format();
        let adminProfile = this._local.customGetItem('admin_profile');
        var selectedTimzoneObj = this.timezones.find((timezone: any) => parseInt(timezone.tzOffset) === selectedUtcOffset);

        if (adminProfile && adminProfile.admin_id) {
          this.insertTimeslotApi(adminProfile.admin_id, startDateTime, endDateTime, "doctor_partner_training", {
            doctor_partner_id: !thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctorId : null,
            trainee_emails: thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctor.doctor_emails : "",
            doctor_practice_name: thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctor.practice_name : "",
            doctor_contact_name: thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctor.doctor_name : "",
            doctor_practice_phone: thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctor.doctor_mobile : "",
            doctor_practice_phone_country_code: this.selectedMobileCode ? this.selectedMobileCode : "",
            doctor_partner_type: thisRef.selectedAppt.training_doctor_partner_type,
            old_event_id: thisRef.selectedAppt.eventId ? thisRef.selectedAppt.eventId : null,
            event_training_status: thisRef.selectedAppt.eventId ? 3 : null,
            training_type: thisRef.selectedAppt.selectedTraining,
            event_desc: thisRef.selectedAppt.trainingNote,
            timezone_short_name: selectedTimzoneObj && selectedTimzoneObj.code,
            timezone_full_name: selectedTimzoneObj && selectedTimzoneObj.name,
            event_token: thisRef.eventToken,
            past_training: 1,
            training_meeting_link: thisRef.selectedAppt.trainingMeetingLink ? this.getUrlWithProtocol(thisRef.selectedAppt.trainingMeetingLink) : "",
            send_email: 1,
            country_id: this.country_id,
            ...this.businessUsersPayload()
          }
            // , function (err: any, data: any) {
            //   if (!err) {
            //     /*thisRef.viewType = "allTimePref";
            //     thisRef.calType = "single_day_view";
            //     thisRef.calWeekOffSetFromCurrentWeek = 0;
            //     thisRef.singleDayDate = thisRef.selectedAppt.date;
            //     thisRef.timeSlotSelectorsDict = {};
            //     thisRef.undoRedoIndex = -1;
            //     thisRef.timeSlotSelectorsDictUndoRedoArray = [];
            //     thisRef.refreshWeekDaysAndMonthDates();
            //     thisRef.createTimeSlotSelectorTable();*/
            //     /*if(thisRef.data.trainingCreatedUpdatedCallback)
            //     {
            //       thisRef.data.trainingCreatedUpdatedCallback();
            //     }*/
            //     var successMsg = "The training was " + (thisRef.selectedAppt.viewType === "newTraining" ? "booked" : "rescheduled") + " successfully";
            //     thisRef._shared.customPopups(successMsg, 0);
            //     thisRef.bsModalRef.content.trainingCreated = data;
            //     thisRef.bsModalRef.content.selectedAppt = thisRef.cloneObj(thisRef.selectedAppt);
            //     thisRef.bsModalRef.content.selectedAppt.schedule_date = moment(thisRef.selectedAppt.date).format("YYYY-MM-DD");
            //     thisRef.bsModalRef.content.selectedAppt.selectedAdminId = selectedAdminId;
            //     thisRef.hideTrainingModal();
            //   } else {
            //     //thisRef.isProcessing = false;
            //     //showLoadingWithMessage("");
            //     //enableDisableFilters(!isProcessing);
            //   }
            // }
          );
        }

      } else {
        var selectedUtcOffset = parseInt(this.selectedAppt.timezone.split("****")[1]);
        var startTimeStamp = parseInt(moment(this.selectedAppt.selectedAvailableStartTime.fullDateTimeString).utc().format("X"));
        var endTimeStamp = startTimeStamp + (this.selectedAppt.trainingDuration * 60);
        var startDateTime = moment(startTimeStamp * 1000).utcOffset(selectedUtcOffset).format();
        var endDateTime = moment(endTimeStamp * 1000).utcOffset(selectedUtcOffset).format();
        if (startTimeStamp > parseInt(moment().utc().format("X"))) {
          // thisRef.isProcessing = true;
          var selectedAdminId = this.selectedAppt.selectedAdminId;
          var excludeAdminId = this.selectedAppt.excludeAdminId ? this.selectedAppt.excludeAdminId : null;
          if (this.selectedAppt.assign_automatic) {
            var availableAdminObjsExceptCurrentAdmin = this.selectedAppt.availableAdminUsers.filter((adminUser: any) => adminUser.admin_id !== excludeAdminId)
            if (availableAdminObjsExceptCurrentAdmin.length) {
              availableAdminObjsExceptCurrentAdmin.sort(function (a: any, b: any) {
                return a.totalAvailableDuration > b.totalAvailableDuration ? -1 : 1
              });
              selectedAdminId = availableAdminObjsExceptCurrentAdmin[0].admin_id;
            }
          }
          var selectedUtcOffset = parseInt(this.selectedAppt.timezone.split("****")[1]);
          var selectedTimzoneObj = this.timezones.find((timezone: any) => parseInt(timezone.tzOffset) === selectedUtcOffset);

          if (selectedAdminId) {
            this.insertTimeslotApi(selectedAdminId, startDateTime, endDateTime, "doctor_partner_training", {
              doctor_partner_id: !thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctorId : null,
              trainee_emails: thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctor.doctor_emails : "",
              doctor_practice_name: thisRef.selectedAppt.out_of_system ? thisRef.selectedAppt.selectedDoctor.practice_name : "",
              doctor_contact_name: thisRef.selectedAppt.out_of_system || !thisRef.selectedAppt.isDoctorPrefilled ? thisRef.selectedAppt.selectedDoctor.doctor_name : "",
              doctor_practice_phone: thisRef.selectedAppt.out_of_system || !thisRef.selectedAppt.isDoctorPrefilled  ? thisRef.selectedAppt.selectedDoctor.doctor_mobile : "",
              doctor_practice_phone_country_code: thisRef.selectedAppt.out_of_system || !thisRef.selectedAppt.isDoctorPrefilled  ? this.selectedMobileCode : "",
              doctor_partner_type: thisRef.selectedAppt.training_doctor_partner_type,
              old_event_id: thisRef.selectedAppt.eventId ? thisRef.selectedAppt.eventId : null,
              event_training_status: thisRef.selectedAppt.eventId ? 3 : null,
              training_type: thisRef.selectedAppt.selectedTraining,
              event_desc: thisRef.selectedAppt.trainingNote,
              timezone_short_name: selectedTimzoneObj.code,
              timezone_full_name: selectedTimzoneObj.name,
              event_token: thisRef.eventToken,
              training_meeting_link: thisRef.selectedAppt.trainingMeetingLink ? this.getUrlWithProtocol(thisRef.selectedAppt.trainingMeetingLink) : "",
              send_email: (this.selectedAppt.out_of_system && this.selectedAppt.viewType === 'newTraining') ? 1 : (this.selectedAppt.send_email ? 1 : 0),
              country_id: this.country_id,
              doctor_email:  this.editableUserEmail,
              ...this.businessUsersPayload()
            }
              // , function (err: any, data: any) {
              //   if (!err) {
              //     /*thisRef.viewType = "allTimePref";
              //     thisRef.calType = "single_day_view";
              //     thisRef.calWeekOffSetFromCurrentWeek = 0;
              //     thisRef.singleDayDate = thisRef.selectedAppt.date;
              //     thisRef.timeSlotSelectorsDict = {};
              //     thisRef.undoRedoIndex = -1;
              //     thisRef.timeSlotSelectorsDictUndoRedoArray = [];
              //     thisRef.refreshWeekDaysAndMonthDates();
              //     thisRef.createTimeSlotSelectorTable();*/
              //     /*if(thisRef.data.trainingCreatedUpdatedCallback)
              //     {
              //       thisRef.data.trainingCreatedUpdatedCallback();
              //     }*/
              //     var successMsg = "The training was " + (thisRef.selectedAppt.viewType === "newTraining" ? "booked" : "rescheduled") + " successfully";
              //     thisRef._shared.customPopups(successMsg, 0);
              //     thisRef.bsModalRef.content.trainingCreated = data;
              //     thisRef.bsModalRef.content.selectedAppt = thisRef.cloneObj(thisRef.selectedAppt);
              //     thisRef.bsModalRef.content.selectedAppt.schedule_date = moment(thisRef.selectedAppt.date).format("YYYY-MM-DD");
              //     thisRef.bsModalRef.content.selectedAppt.selectedAdminId = selectedAdminId;
              //     thisRef.hideTrainingModal();
              //   } else {
              //     //thisRef.isProcessing = false;
              //     //showLoadingWithMessage("");
              //     //enableDisableFilters(!isProcessing);
              //   }
              // }
            );
          } else {
            thisRef._shared.customPopups("No CSR available", 1);
          }

        } else {
          thisRef._shared.customPopups("You cannot add training in past time", 1);
        }
      }
    }
    return;
  }




  insertTimeslotApi(userId: any, startDateTime: any, endDateTime: any, timeSlotType: any, extraData: any) {

    var reqData: any = {

      admin_id: userId,
      start_date_time: startDateTime,
      end_date_time: endDateTime,
      time_slot_type: timeSlotType,
      send_email: extraData.send_email
    }
    if (extraData.training_meeting_link) {
      reqData['training_meeting_link'] = extraData.training_meeting_link;
    }
    if (timeSlotType === "doctor_partner_training") {
      reqData["event_desc"] = extraData.event_desc;
      if (extraData.doctor_partner_id) {
        reqData["doctor_partner_id"] = extraData.doctor_partner_id;
      }

      if (extraData.trainee_emails) {
        reqData["trainee_emails"] = extraData.trainee_emails;
      }
      if (extraData.doctor_practice_name) {
        reqData["doctor_practice_name"] = extraData.doctor_practice_name;
      }
      if (extraData.doctor_contact_name) {
        reqData["doctor_contact_name"] = extraData.doctor_contact_name;
      }
      if (extraData.doctor_practice_phone) {
        reqData["doctor_practice_phone"] = extraData.doctor_practice_phone;
      }

      reqData["doctor_partner_type"] = extraData.doctor_partner_type;
      reqData["training_type"] = extraData.training_type;

      if (extraData.old_event_id) {
        reqData["old_event_id"] = extraData.old_event_id;
      }
      if (extraData.event_training_status) {
        reqData["event_training_status"] = extraData.event_training_status;
      }
      if (extraData.doctor_practice_phone_country_code) {
        reqData["doctor_practice_phone_country_code"] = extraData.doctor_practice_phone_country_code;
      }
    }

    if (extraData.event_token) {
      reqData["event_token"] = extraData.event_token + "";
    }

    if (extraData.timezone_short_name) {
      reqData["timezone_short_name"] = extraData.timezone_short_name;
    }

    if (extraData.timezone_full_name) {
      reqData["timezone_full_name"] = extraData.timezone_full_name;
    }
    if (extraData && extraData.past_training === 1) {
      reqData["past_training"] = extraData.past_training;
    }
    if (extraData && extraData.country_id) {
      reqData["country_id"] = extraData.country_id;
    }
    if (extraData.agent_ids && extraData.agent_ids.length) {
      reqData["agent_ids"] = extraData.agent_ids;
    }
    if (extraData.agent_details && extraData.agent_details.length) {
      reqData["agent_details"] = extraData.agent_details;
    }
    // A business-user training sends each user's edits in agent_details instead of these single fields.
    if (!this.isAgentTrainingEdit) {
      if(this.editableUserName)
      {
        reqData["doctor_name"] = this.editableUserName;
      }
      if(this.editableUserEmail)
      {
        reqData["doctor_email"] = this.editableUserEmail;
      }
      if(this.editableUserPhone)
      {
        reqData["doctor_phone"] = this.editableUserPhone;
      }
    }
    if(this.editableUserWebsite)
    {
      reqData["doctor_website_link"] = this.editableUserWebsite;
    }
    // this.editableUserName   = this.selectedAppt.selectedDoctor.doctor_name || '';
    // this.editableUserEmail  = this.selectedAppt.selectedDoctor.doctor_emails || '';
    // this.editableUserPhone  = this.selectedAppt.selectedDoctor.practice_mobile || '';
    // this.editableUserWebsite = this.selectedAppt.selectedDoctor.Website || '';
    reqData['attachments'] = this.buildAttachmentsPayload();

    const thisRef = this;
    this._api.api(reqData, 'scheduler/insert_time_slot')
      .subscribe((data: any) => {
        console.log("data");
        console.log(data);
        if (!data.is_error) {
          var successMsg = "The training was " + (thisRef.selectedAppt.viewType === "newTraining" ? "booked" : "rescheduled") + " successfully";
          thisRef._shared.customPopups(successMsg, 0);
          if (this.bsModalRef && thisRef.bsModalRef.content) {
            thisRef.bsModalRef.content.trainingCreated = data;
            thisRef.bsModalRef.content.selectedAppt = thisRef.cloneObj(thisRef.selectedAppt);
            thisRef.bsModalRef.content.selectedAppt.schedule_date = moment(thisRef.selectedAppt.date).format("YYYY-MM-DD");
            thisRef.bsModalRef.content.selectedAppt.selectedAdminId = userId;
          }
          thisRef.hideTrainingModal();
        }
        else {
          thisRef._shared.customPopups(data.original_text, 1);
        }
      });
  }

  // autocomplete functions for admin, doctor and zip
  // fetching data
  fetchAdminList(event: any) {
    /*let data = {
      access_token: this._local.customGetItem('token
    };
    if ((event && event.length > 3)) {
      data['search_string'] = event;
    } else {
      return false;
    }
    this.admin.loading = true;
    this._api.api(data, 'fetch_admin_list', false)
      .subscribe((data: any) => {
        if (data.data && data.data.length) {
          this.admin.data = data.data;
        }
        this.admin.loading = false;
        this.admin.error = false;
      }, (error: any) => {
        this.admin.loading = false;
        this.admin.error = true;
        console.log(error);
      });*/
  }
  // fetching data
  fetchAvailableAdminList(event: any) {
    /*let data = {
      
      schedule_time: moment(this.apt_data.time).format("HH:mm"),
      schedule_timezone: this.apt_data.timezone?this.apt_data.timezone:'',
      duration: this.apt_data.duration?this.apt_data.duration:0,
      schedule_date: this.apt_data.date?moment(this.apt_data.date).format("YYYY-MM-DD"):''
    };
    if(!data.schedule_date){
      this._shared.customPopups('Please select date first', 2);
      return false;
    }
    if(!data.schedule_time){
      this._shared.customPopups('Please select time first', 2);
      return false;
    }
    if(!data.duration){
      this._shared.customPopups('Please select duration first', 2);
      return false;
    }
    if(!data.schedule_timezone){
      this._shared.customPopups('Please select timezone first', 2);
      return false;
    }
    if ((event && event.length > 3)) {
      data['search_string'] = event;
    } else {
      return false;
    }
    this.admin.loading = true;
    this._api.api(data, 'fetch_available_admins', false)
      .subscribe((data: any) => {
        if (data.data && data.data.length) {
          this.admin.data = data.data;
        }
        this.admin.loading = false;
        this.admin.error = false;
      }, (error: any) => {
        this.admin.loading = false;
        this.admin.error = true;
        console.log(error);
      });*/
  }


  fetchDoctorList(event: any) {
    // Whitespace is not a search term -- see the same guard in training-list.component.ts. The API
    // validates search_string as required but only filters on it when non-blank, so " " returns an
    // unfiltered page of businesses and puts a blank, selectable option in the dropdown.
    if (!(event && String(event).trim())) {
      return false;
    }
    const searchString = String(event).trim();
    if (this.searchDoctorTimeOutRef) {
      clearTimeout(this.searchDoctorTimeOutRef);
    }
    this.searchDoctorTimeOutRef = setTimeout(() => {
      this.searchDoctorTimeOutRef = null;
      // a new search starts again from the first page
      this.doctorSearchString = searchString;
      this.doctorNextOffset = 0;
      this.doctorHasMore = false;
      this.loadDoctorPage(false);
    }, 500);
    return;
  }

  // One page of the Business / Partner search. The first page replaces the list; later pages are appended.
  loadDoctorPage(append: boolean) {
    if (this.doctorSearchRequest) {
      this.doctorSearchRequest.unsubscribe();
    }
    const isDoctor = this.selectedAppt.training_doctor_partner_type == 'doctor';
    const searchString = this.doctorSearchString;
    const params = { search_string: searchString, offset: this.doctorNextOffset, limit: this.doctorPageLimit };
    this.doctorItemsSource = null;
    this.doctorPageLoading = true;
    // silent: the skeleton rows in the dropdown stand in for the full-screen overlay. (api() ignores
    // hide_loader at the moment -- its check is commented out -- so the silent flag is what skips the loader.)
    this.doctorSearchRequest = this._api.api(params, isDoctor ? 'scheduler/search_doctors' : 'search_partner', 'get', {silent : true})
      .subscribe((data: any) => {
        this.doctorPageLoading = false;
        const page: any[] = (data && (isDoctor ? data.data : data.partner_list)) || [];
        const idField = isDoctor ? 'doctor_id' : 'partner_id';
        if (append) {
          const known = new Set(this.selectedAppt.doctors.map((item: any) => item[idField]));
          this.selectedAppt.doctors = [...this.selectedAppt.doctors, ...page.filter((item: any) => !known.has(item[idField]))];
        } else if (page.length) {
          this.selectedAppt.doctors = page;
        }
        this.doctorNextOffset += page.length;
        this.doctorHasMore = page.length >= this.doctorPageLimit;
      }, (error: any) => {
        this.doctorPageLoading = false;
      });
  }

  // Scrolling to the bottom of the Business / Partner dropdown requests the next offset.
  onDoctorDropdownScroll(event: Event) {
    const menu = event.target as HTMLElement;
    if (!menu || !menu.classList || !menu.classList.contains('ngx-select__choices') || !menu.closest('.doctor-select-wrap')) {
      return;
    }
    if (!this.doctorHasMore || this.doctorPageLoading) {
      return;
    }
    if (menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 20) {
      this.ngZone.run(() => this.loadDoctorPage(true));
    }
  }
  // clearing data // selecting data 
  selectApptAdmin() {
    //this.selectedAppt.selectedAvailableStartTime = null;
    var adminObj = this.selectedAppt.adminUsers.find((adminUser: any) => adminUser.admin_id === this.selectedAppt.selectedAdminId);
    this.selectedAppt.selectedAdmin = adminObj;
    console.log(adminObj);
  }

  onTrainingSelect() {
    var trainingObj = this.selectedAppt.trainingTypes.find((training: any) => training.type_id + "" === this.selectedAppt.selectedTraining + "");
    this.selectedAppt.trainingDuration = trainingObj ? trainingObj.duration : null;
    //vm.addTraining.duration = vm.trainingTypes.find((trType)=>trType.type_id === vm.addTraining.training_type).duration;
    //this.getDateWithTimeSlots();
    this.getAvailableSlotsOnAppointmentDate();
  }
  trainingDateChanged() {
    this.getAvailableSlotsOnAppointmentDate();
  }

  trainingTimezoneChanged() {
    //this.getDateWithTimeSlots();
    if (this.selectedAppt.viewType !== "newTraining") {
      var selectedUtcOffset = parseInt(this.selectedAppt.timezone && this.selectedAppt.timezone.split("****")[1]);
      var applicableOffset = this.getApplicableOffsetBasedOnDaylight(this.selectedAppt.training_timezone_short_name, this.selectedAppt.training_timezone_offset);
      var schedule_date = moment(parseInt(this.selectedAppt.training_start_timestamp) * 1000).utcOffset(applicableOffset).format("MM/DD/YYYY");
      var schedule_time = moment(parseInt(this.selectedAppt.training_start_timestamp) * 1000).utcOffset(applicableOffset).format("hh:mm A");
      this.selectedAppt.schedule_date = schedule_date;
      this.selectedAppt.schedule_time = schedule_time;

      
      // const filterItem = this.timezones.find((item: any) => item.offset === this.timezoneName);
      // console.log(filterItem?.zone);
      // this.selectedAppt.schedule_date = moment(this.selectedAppt.followup_date).tz(filterItem?.zone).format('MM/DD/YYYY')
      // this.selectedAppt.schedule_time = moment(this.selectedAppt.followup_date).tz(filterItem?.zone).format('hh:mm A')
    }
    this.getAvailableSlotsOnAppointmentDate();
  }

  getAvailableSlotsOnAppointmentDate() {
    this.selectedAppt.availableTimeSlots = [];
    this.selectedAppt.adminUsers = [];
    this.selectedAppt.availableAdminUsers = [];
    this.selectedAppt.availableStartTimes = [];
    this.selectedAppt.selectedAdminId = null;
    this.selectedAppt.selectedAdmin = null;
    this.selectedAppt.selectedAvailableStartTime = null;

    var selectedUtcOffset;
    if (this.viewType === 'changeAssignee') {
      selectedUtcOffset = this.data.training_timezone_offset;
    } else {
      selectedUtcOffset = this.selectedAppt.timezone && parseInt(this.selectedAppt.timezone.split("****")[1]);
    }
    var timezone_short_name = this.selectedAppt.timezone && this.selectedAppt.timezone.split("****")[0];
    var timezoneHours = parseInt((selectedUtcOffset / 60) + "");
    timezoneHours = timezoneHours < 0 ? (-1 * timezoneHours) : timezoneHours;
    var timezoneMinutes = (selectedUtcOffset % 60);
    timezoneMinutes = timezoneMinutes < 0 ? (-1 * timezoneMinutes) : timezoneMinutes;
    var timezoneString = (selectedUtcOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0" : "") + timezoneHours + ":" + (timezoneMinutes < 10 ? "0" : "") + timezoneMinutes;
    var startDateString;
    if (this.viewType === 'changeAssignee') {
      startDateString = moment.utc(this.selectedAppt.date).format("YYYY-MM-DD") + "T00:00:00" + timezoneString;
      timezone_short_name = this.data.training_timezone_short_name;
    } else {
      startDateString = (moment(this.selectedAppt.date).format("YYYY-MM-DD")) + "T00:00:00" + timezoneString;
    }
    var startDateTimestamp = parseInt(moment(startDateString).utc().format("X"));
    var endDateTimestamp = startDateTimestamp + (24 * 60 * 60);
    var endDateString = endDateTimestamp && moment(endDateTimestamp * 1000).utcOffset(selectedUtcOffset).format();

    var reqData = {

      start_date: startDateString,
      end_date: endDateString,
      timezone_short_name: timezone_short_name,
      country_id: this.country_id,
      doctor_partner_type: this.data.doctor_partner_type

    }

    var thisRef = this;

    this._api.api(reqData, "scheduler/get_time_slots_for_multiple_users", 'get')
      .subscribe((data: any) => {
        this.fetchAdminListApi((err: any, adminData: any) => {
          var adminsSchedules = data.adminsSchedules;
          if (adminsSchedules) {
            for (var key in adminsSchedules) {
              var adminUsers = adminData.data;
              var adminObj = adminUsers.find((adminUser: any) => "admin" + adminUser.admin_id === key);
              //if(thisRef.selectedAppt.viewType === "newTraining" || key !== "admin"+thisRef.selectedAppt.excludeAdminId)
              if (thisRef.selectedAppt.viewType === "newTraining" || thisRef.selectedAppt.viewType === "editTraining" || thisRef.selectedAppt.viewType == 'changeAssignee') {
                //if(adminObj !== null)
                if (adminObj) {
                  let selectedDate;
                  if (thisRef.selectedAppt.viewType === 'changeAssignee') {
                    selectedDate = this.data.startDateString;
                  } else {
                    selectedDate = thisRef.selectedAppt.date;
                  }
                  //var adminColIndex = adminObj.admin_index;
                  var selectedDateStr = moment(selectedDate).format("YYYY-MM-DD");
                  var selectedDateObj = adminsSchedules[key].dates.find((dateObj: any) => dateObj.date === selectedDateStr);
                  if (selectedDateObj) {
                    var dateTimeSlots = selectedDateObj.timeSlots ? selectedDateObj.timeSlots : [];
                    dateTimeSlots = dateTimeSlots.filter((timeslot: any) => timeslot.type === "available");
                    if (dateTimeSlots.length) {
                      dateTimeSlots.sort(function (a: any, b: any) {
                        return a.startMinutes + a.endMinutes > b.startMinutes + b.endMinutes ? 1 : -1;
                      });
                      var clubbedTimeSlots = [];
                      for (var i = 0; i < dateTimeSlots.length; i++) {
                        if (!clubbedTimeSlots.length) {
                          clubbedTimeSlots.push(dateTimeSlots[i]);
                        }
                        else {
                          if (dateTimeSlots[i].startMinutes === clubbedTimeSlots[clubbedTimeSlots.length - 1].endMinutes) {
                            clubbedTimeSlots[clubbedTimeSlots.length - 1].endMinutes = dateTimeSlots[i].endMinutes;
                          }
                          else {
                            clubbedTimeSlots.push(dateTimeSlots[i]);
                          }
                        }
                      }

                      var totalAvailableDurationOfAdmin = 0;
                      for (var i = 0; i < clubbedTimeSlots.length; i++) {
                        totalAvailableDurationOfAdmin += (clubbedTimeSlots[i].endMinutes - clubbedTimeSlots[i].startMinutes)
                      }

                      clubbedTimeSlots = clubbedTimeSlots.filter((timeSlot) => (timeSlot.endMinutes - timeSlot.startMinutes) >= thisRef.selectedAppt.trainingDuration);

                      var availableStartTimes = [];

                      for (var i = 0; i < clubbedTimeSlots.length; i++) {
                        for (var j = clubbedTimeSlots[i].startMinutes; j <= clubbedTimeSlots[i].endMinutes - thisRef.selectedAppt.trainingDuration; j += thisRef.minTimeGap) {
                          var timeHours = parseInt((j / 60) + "");
                          var timeMinutes = j % 60;
                          var timeString = (((timeHours >= 10 ? "" : "0") + timeHours) + ":" + ((timeMinutes >= 10 ? "" : "0") + timeMinutes));
                          var fullDateTimeString = moment(thisRef.selectedAppt.date).format("YYYY-MM-DD") + "T" + timeString + ":00" + timezoneString;
                          if (parseInt(moment().utc().format("X")) < parseInt(moment(fullDateTimeString).utc().format("X"))) {
                            var timeAmPm = moment(moment(thisRef.selectedAppt.date).format("YYYY-MM-DD") + "T" + timeString).format("hh:mm A");
                            var timeObj = {
                              time: timeString,
                              fullDateTimeString: fullDateTimeString,
                              timeAmPm: timeAmPm,
                            }
                            availableStartTimes.push(timeObj);
                            if (thisRef.selectedAppt.availableStartTimes.filter((availableStartTimeObj: any) => availableStartTimeObj.timeAmPm === timeAmPm).length === 0) {
                              thisRef.selectedAppt.availableStartTimes.push(timeObj);
                            }
                          }
                        }
                      }
                      if (availableStartTimes.length) {
                        //adminObj["availableTimeSlots"] = clubbedTimeSlots;
                        adminObj["availableStartTimes"] = availableStartTimes;
                        adminObj["totalAvailableDuration"] = totalAvailableDurationOfAdmin;

                        thisRef.selectedAppt.adminUsers.push(adminObj);
                      }
                    }
                  }
                }
              }

            }
            thisRef.selectedAppt.availableStartTimes.sort(function (a: any, b: any) {
              return a.time > b.time ? 1 : -1
            });
            if (thisRef.selectedAppt.viewType == 'changeAssignee') {
              const [data] = thisRef.selectedAppt.availableStartTimes.filter((slot: any) => {
                return slot.timeAmPm == this.data.trainingTime;
              })
              if (data) {
                this.selectTrainingTime(data)
              }
            }
          }
        });
      });

  }

  selectTrainingDoctor(event: any) {
    var selectedDoctor: any = {};
    if (this.selectedAppt.training_doctor_partner_type == 'partner') {
      selectedDoctor = this.selectedAppt.doctors.find((doctor: any) => doctor.partner_id === this.selectedAppt.selectedDoctorId);
      selectedDoctor['doctor_name'] = selectedDoctor['partner_name'];
      selectedDoctor['doctor_email'] = selectedDoctor['partner_email'];
      selectedDoctor['doctor_mobile'] = selectedDoctor['partner_mobile'];
      selectedDoctor['doctor_mobile_country_code'] = selectedDoctor['partner_mobile_country_code']
    } else {
      selectedDoctor = this.selectedAppt.doctors.find((doctor: any) => doctor.doctor_id === this.selectedAppt.selectedDoctorId);
    }
    if (selectedDoctor) {
      this.selectedAppt.selectedDoctor = selectedDoctor;
      this.selectedAppt.selectedDoctor.doctor_emails =  selectedDoctor['doctor_email'] ? selectedDoctor['doctor_email'] :selectedDoctor['doctor_emails'];
    }
    this.selectedMobileCode = selectedDoctor && selectedDoctor['doctor_mobile_country_code'];
    // A different business has different users.
    this.clearBusinessUsers();
    if (this.selectedAppt.book_for === 'business_user') {
      this.fetchBusinessUsers(this.selectedAppt.selectedDoctorId);
    }
  }

  isPhoneNumberValid(phoneNumber: any) {
    var updatedPhoneNumber = phoneNumber ? (phoneNumber + "").split(" ").join("").split("+").join("").split("-").join("") : "";
    return (updatedPhoneNumber + "").length === 10 && /^\d+$/.test(updatedPhoneNumber);
  }

  isValidEmail(email: any) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase()) && (email.length <= 256);
  }

  isValidUrl(url: any) {
    var urlStrinhWithProtocol = this.getUrlWithProtocol(url);
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(urlStrinhWithProtocol);
  }

  getUrlWithProtocol(url: any) {
    var protocols = ["http://", "https://"];
    var hasProtocol = false;
    for (var i = 0; i < protocols.length; i++) {
      if (url.indexOf(protocols[i]) === 0) {
        hasProtocol = true;
      }
    }
    return (!hasProtocol ? "https://" : "") + url;
  }

  selectTrainingTime(selectedAvailableStartTime: any) {
    this.selectedAppt.selectedAvailableStartTime = selectedAvailableStartTime;
    this.selectedAppt.selectedAdmin = null;
    this.selectedAppt.selectedAdminId = null;
    this.selectedAppt.availableAdminUsers = this.selectedAppt.adminUsers.filter((adminUser: any) => {
      return adminUser.availableStartTimes.filter((availableStartTime: any) => availableStartTime.timeAmPm === selectedAvailableStartTime.timeAmPm).length > 0;
    });
  }

  trainingDurationChanged() {
    this.getAvailableSlotsOnAppointmentDate();
  }
  editBusinessDetail(event:any,type:any){
    console.log(event,type );
  }

  addEmails(event: any, form: any) {
    //console.log('event.keyCode---',form,form.value.cEmail, form.controls['cEmail'].valid)
    /*if(form && form.value.cEmail && form.controls['cEmail'].valid){
      let index = this.doctorEmails.findIndex(x => x == form.value.cEmail);
      if (index == -1) {
        this.doctorEmails.push(form.value.cEmail)
      } else {
        this._shared.customPopups('Email already added', 2);
      }
      console.log(this.doctorEmails);
      form.controls['cEmail'].reset();
      //console.log('form---',form)
    }*/

  }

  removeEmail(email: any) {
    /*let index = this.doctorEmails.findIndex(x => x == email);
    if (index > -1) {
      this.doctorEmails.splice(index, 1);
    }*/
  }


  fetchEventDetailsApi(event_id: any, callback: any) {
    let reqData = {

      //admin_id: admin_id,
      event_id: event_id,
    };
    this._api.api(reqData, 'scheduler/get_event_details', 'get')
      .subscribe((data: any) => {
        if (!data.is_error) {
          if (callback) {
            callback(null, data);
          }
        }
        else {
          if (callback) {
            callback(data.err, null);
          }
        }
      });
  }

  updateEventStatusNotesApi(event_id: any, event_desc: any, training_status: any, send_email: any, extraData: any, callback: any) {
    let reqData: any = {

      training_status: training_status,
      training_desc: event_desc,
      event_id: event_id,
      send_email: send_email,
    };
    if (training_status) {
      reqData.training_status = training_status;
    }

    if (extraData.event_token) {
      reqData["event_token"] = extraData.event_token + "";
    }
    // Always send this explicitly (even as null) so clearing the follow-up date (e.g. switching to No Show
    // with no date) actually clears it server-side instead of leaving a stale value untouched.
    reqData["followup_date"] = extraData.followup_date || null;

    if (extraData.agent_ids && extraData.agent_ids.length) {
      reqData["agent_ids"] = extraData.agent_ids;
    }
    if (extraData.agent_details && extraData.agent_details.length) {
      reqData["agent_details"] = extraData.agent_details;
    }
    // A business-user training sends each user's edits in agent_details instead of these single fields.
    if (!this.isAgentTrainingEdit) {
    if(this.editableUserName)
      {
        reqData["doctor_name"] = this.editableUserName;
      }
      if(this.editableUserEmail)
      {
        reqData["doctor_email"] = this.editableUserEmail;
      }
      if(this.editableUserPhone)
      {
        reqData["doctor_phone"] = this.editableUserPhone;
      }
    }
      if(this.editableUserWebsite)
      {
        reqData["doctor_website_link"] = this.editableUserWebsite;
      }
      reqData['attachments'] = this.buildAttachmentsPayload();

    this._api.api(reqData, 'scheduler/update_event_status_notes')
      .subscribe((data: any) => {
        if (!data.is_error) {
          if (callback) {
            callback(null, data);
          }
        } else {
          if (callback) {
            callback(data.err, null);
          }
        }
      }, (err: any) => {
        if (callback) {
          callback(err, null);
        }
      });
  }

  fetchAdminListApi(callback: any) {
    if (this._shared.getAdminList() && this._shared.getAdminList().length > 0) {
      callback(null, { data: this._shared.getAdminList() });
    } else {
      setTimeout(() => {
        this.fetchAdminListApi(callback);
      }, 100);
    }
  }

  fetchTrainingStatusesApi(callback: any) {
    let reqData = {  };
    this._api.api(reqData, 'scheduler/get_training_statuses', 'get')
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          if (callback) {
            callback(null, data);
          }
        } else {
          if (callback) {
            callback(data.err, null);
          }
        }
      }, (error: any) => {
        console.log(error);
        if (callback) {
          callback(error, null);
        }
      });
  }

  cloneObj(obj: any) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
  }
  // ---- Business users (agents) of a training ---------------------------------------------------------
  // A training can be booked for one or more registered users of a business, all in one session. Each user
  // has their own Name / Email / Contact for that training, edited on Update Training Status / Reschedule.

  // An existing business-user training: its users are listed and edited one row each.
  get isAgentTrainingEdit(): boolean {
    return !!(this.selectedAppt && this.selectedAppt.book_for === 'business_user' && this.selectedAppt.viewType !== 'newTraining');
  }

  // "Book Training For" switched between Business and Business Users. Business Users is registered-only,
  // so Unregistered is turned off; the business already picked is kept.
  bookForChanged() {
    if (this.selectedAppt.out_of_system) {
      this.selectedAppt.out_of_system = false;
      this.outOfSystemChanged();
    }
    this.clearBusinessUsers();
    if (this.selectedAppt.book_for === 'business_user' && this.selectedAppt.selectedDoctorId) {
      this.fetchBusinessUsers(this.selectedAppt.selectedDoctorId);
    }
  }

  clearBusinessUsers() {
    if (!this.selectedAppt) {
      return;
    }
    this.selectedAppt.selectedAgentIds = [];
    this.selectedAppt.businessUsers = [];
    this.selectedAppt.agentDetails = [];
  }

  // Active users of the business for the Business User(s) dropdown. Users already on the training are kept
  // in the list even if they have since been blocked, so the existing selection isn't silently dropped.
  fetchBusinessUsers(doctorId: any, keepSelection = false, attendingAgents: any[] = []) {
    if (!keepSelection) {
      this.selectedAppt.selectedAgentIds = [];
    }
    this.selectedAppt.businessUsers = [];
    if (!doctorId) {
      return;
    }
    // The API pages at 10 by default.
    const params = { doctor_id: doctorId, is_blocked: 0, limit: 500, offset: 0 };
    this._api.api(params, 'business/get_doctor_agents', 'get').subscribe((data: any) => {
      const users = data && data.is_error == 0 && data.paignated_result ? data.paignated_result : [];
      users.forEach((user: any) => user.agent_id = Number(user.agent_id));
      attendingAgents.forEach((agent: any) => {
        if (!users.some((user: any) => user.agent_id === Number(agent.agent_id))) {
          users.push({ agent_id: Number(agent.agent_id), agent_name: agent.training_agent_name, agent_email: agent.training_agent_email });
        }
      });
      this.selectedAppt.businessUsers = users;
    });
  }

  // Users added / removed on an existing training: add a row (from the user's profile) or drop it.
  selectedAgentsChanged() {
    if (!this.isAgentTrainingEdit) {
      return;
    }
    const ids = (this.selectedAppt.selectedAgentIds || []).map(Number);
    const rows = (this.selectedAppt.agentDetails || []).filter((row: any) => ids.includes(Number(row.agent_id)));
    ids.filter((id: number) => !rows.some((row: any) => Number(row.agent_id) === id)).forEach((id: number) => {
      const user = (this.selectedAppt.businessUsers || []).find((item: any) => Number(item.agent_id) === id) || {};
      const phone = user.agent_mobile ? (String(user.agent_mobile).startsWith('+') ? user.agent_mobile : `+1-${user.agent_mobile}`) : '';
      rows.push(this.agentRow(id, user.agent_name, user.agent_email, phone));
    });
    // keep the dropdown's order, so the first selected stays first (the primary)
    this.selectedAppt.agentDetails = ids.map((id: number) => rows.find((row: any) => Number(row.agent_id) === id)).filter(Boolean);
  }

  // One editable row. A user with no number is shown the business owner's as a stand-in, the same rule as
  // the single Contact input; it is only saved for the user if the admin actually changes it.
  agentRow(agentId: any, name: any, email: any, phone: any) {
    const shownPhone = phone || this.ownerStandInPhone();
    const row = {
      agent_id: Number(agentId),
      training_agent_name: name || '',
      training_agent_email: email || '',
      training_agent_phone: shownPhone,
      original: { training_agent_name: name || '', training_agent_email: email || '', training_agent_phone: shownPhone }
    };
    return row;
  }

  ownerStandInPhone(): string {
    return this.allEventData && this.allEventData.doctor_mobile ? `+1-${this.allEventData.doctor_mobile}` : '';
  }

  onAgentPhoneInput(row: any) {
    if (row.training_agent_phone && !row.training_agent_phone.startsWith("+1-")) {
      row.training_agent_phone = "+1-" + row.training_agent_phone.replace(/\D/g, "");
    }
    if (row.training_agent_phone && row.training_agent_phone.startsWith("+1-")) {
      const digits = row.training_agent_phone.replace("+1-", "").replace(/\D/g, "");
      row.training_agent_phone = "+1-" + digits.substring(0, 10);
    }
  }

  agentDetailsValid(): boolean {
    return (this.selectedAppt.agentDetails || []).every((row: any) =>
      row.training_agent_name && row.training_agent_name.trim() && row.training_agent_name.length <= 256 &&
      row.training_agent_email && this.emailPattern.test(row.training_agent_email) &&
      (!row.training_agent_phone || this.phonePattern.test(row.training_agent_phone)));
  }

  agentIdsChanged(): boolean {
    const before = [...(this.selectedAppt.originalAgentIds || [])].map(Number).sort((a, b) => a - b);
    const after = [...(this.selectedAppt.selectedAgentIds || [])].map(Number).sort((a, b) => a - b);
    return before.length !== after.length || before.some((id: number, i: number) => id !== after[i]);
  }

  // Only users whose Name / Email / Contact differ from what was loaded, and only the changed fields.
  changedAgentDetails(): any[] {
    return (this.selectedAppt.agentDetails || []).map((row: any) => {
      const changed: any = { agent_id: Number(row.agent_id) };
      ['training_agent_name', 'training_agent_email', 'training_agent_phone'].forEach((field: string) => {
        if ((row[field] || '').trim() !== (row.original[field] || '').trim()) {
          changed[field] = (row[field] || '').trim();
        }
      });
      return changed;
    }).filter((changed: any) => Object.keys(changed).length > 1);
  }

  // agent_ids / agent_details for insert_time_slot: the chosen users on a new training; on a reschedule
  // only what changed.
  businessUsersPayload(): any {
    const appt = this.selectedAppt;
    if (!appt || appt.book_for !== 'business_user') {
      return {};
    }
    if (appt.viewType === 'newTraining') {
      return { agent_ids: (appt.selectedAgentIds || []).map(Number) };
    }
    const payload: any = {};
    if (this.agentIdsChanged()) {
      payload.agent_ids = (appt.selectedAgentIds || []).map(Number);
    }
    const agentDetails = this.changedAgentDetails();
    if (agentDetails.length) {
      payload.agent_details = agentDetails;
    }
    return payload;
  }

  // Trainee Details header: every user of the training as saved, primary first.
  trainingAgentsText(field: string): string {
    const rows = (this.allEventData && this.allEventData.training_agents) || [];
    const values = rows.map((row: any) => row[field]).filter((value: any) => !!value);
    return values.length ? values.join(', ') : 'N.A.';
  }

  resetTraineeSelection() {
    if (this.selectedAppt.out_of_system) {
      this.selectedAppt.selectedDoctor = {};
    } else {
      this.selectedAppt.selectedDoctor = null;
    }
    this.selectedAppt.selectedDoctorId = null
    this.clearBusinessUsers();
  }
  changeMobileCode(mobile_code: any) {
    this.selectedMobileCode = mobile_code;
  }
  shouldShowOption(trainingStatusId: number, selectedAppt: any): boolean {
    if (trainingStatusId !== 1 && trainingStatusId !== 9) {
      return true;
    } else if (trainingStatusId === 9) {
      console.log(!selectedAppt.training_doctor_partner_id || selectedAppt.training_source === 'partner');
      return !selectedAppt.training_doctor_partner_id || selectedAppt.training_source === 'partner';
    }
    return false;
  }

  disableKeyDown(event: KeyboardEvent): void {
    event.preventDefault();
  }
  onPhoneInput() {
    // If user starts typing digits, auto-add +1-
    if (this.editableUserPhone && !this.editableUserPhone.startsWith("+1-")) {
      this.editableUserPhone = "+1-" + this.editableUserPhone.replace(/\D/g, "");
    }
  
    // Keep only digits after +1-
    if (this.editableUserPhone.startsWith("+1-")) {
      const digits = this.editableUserPhone.replace("+1-", "").replace(/\D/g, "");
      this.editableUserPhone = "+1-" + digits.substring(0, 10); // limit to 10 digits

  }
}

  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab'
    ];
  
    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }
  
    // Block anything that is not a number
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  handleWebsite() {
    if (!this.editableUserWebsite) {
      this.isWebsiteValid = true;
      return;
    }
  
    const value = this.editableUserWebsite.trim();
  
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/;
  
    this.isWebsiteValid = urlPattern.test(value);
  }

  sendEmail(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    console.log(checked,"bygyg");
    this.send = checked? 1 : 0
  }
  
  changeScheduledTrainingAssignee(): void {
    // 1. Validate admin selection
    if (!this.data?.training_admin_id || !this.selectedAppt?.selectedAdmin?.admin_id) {
      this._shared.customPopups('Please select a support agent first', 2);
      return;
    }

    // 2. Prepare date objects
    const startTimestamp = this.data.training_start_timestamp;
    const endTimestamp = this.data.training_end_timestamp;

    if (!startTimestamp || !endTimestamp) {
      this._shared.customPopups('Start or end date is missing', 2);
      return;
    }

    const startDate = new Date(startTimestamp * 1000);
    const endDate = new Date(endTimestamp * 1000);

    const start = this.convertToDateTimeFormat(startDate);
    const end = this.convertToDateTimeFormat(endDate);

    // var selectedUtcOffset = this.selectedAppt.timezone && parseInt(this.selectedAppt.timezone.split("****")[1]);
    var selectedUtcOffset = this.data.originalTimezoneOffset
    var startTimeStamp = parseInt(moment(this.selectedAppt.selectedAvailableStartTime.fullDateTimeString).utc().format("X"));
    var endTimeStamp = startTimeStamp + (this.selectedAppt.trainingDuration * 60);
    var startDateTime = moment(startTimeStamp * 1000).utcOffset(selectedUtcOffset).format();
    var endDateTime = moment(endTimeStamp * 1000).utcOffset(selectedUtcOffset).format();
    
    // 3. Build payload
    const payload = {
      doctor_partner_id: this.data.training_doctor_partner_id,
      doctor_partner_type: this.data.doctor_partner_type || 'doctor',
      training_type: this.data.doctor_partner_training_type,
      event_type: this.data.event_type || '7',
      training_status: this.data.training_status,
      old_admin_id: this.data.training_admin_id,
      new_admin_id: this.selectedAppt.selectedAdmin.admin_id,
      event_slot_id: this.data.training_event_time_slot_id,
      start_date: { dateTime: startDateTime },
      end_date: { dateTime: endDateTime },
      event_start_timestamp: startTimestamp,
      event_end_timestamp: endTimestamp,
      timezone_short_name: this.data.training_timezone_short_name,
      training_meeting_link: this.data.training_meeting_link,
      note: this.selectedAppt.trainingNote?.trim() || '',
      training_timezone_full_name: this.data.training_timezone_full_name,
      training_timezone_offset: String(this.data.originalTimezoneOffset),
      start_date_string: startDateTime,
      end_date_string: endDateTime,
    };

    // 4. API call
    this._api.api(payload, 'scheduler/change_assignee', 'post').subscribe({
      next: (res: any) => {
        if (res?.flag === 200) {
          this._shared.customPopups(
            'Support agent assigned successfully!',
            0
          );

          // Safely update modal return data
          this.bsModalRef.content = {
            ...this.bsModalRef.content,
            changeAssignee: {
              assigneeChanged: true,
              newEventId: res?.newEventId
            }
          };
          setTimeout(() => this.hideTrainingModal(), 1000);
        } else {
          this._shared.customPopups(
            res?.original_text || 'Failed to assign support agent',
            2
          );
        }
      },
      error: (err) => {
        console.error('Change assignee error:', err);
        this._shared.customPopups('Error saving support agent', 2);
      }
    });
  }


  editAdmin() {
    setTimeout(() => this.hideTrainingModal(), 1000);
    this.bsModalRef.content.rescheduleTraining = true;
    
    // this.viewType = 'rescheduleTraining';
    // console.log(this.selectedAppt.date);
    // if (this.selectedAppt.date) {
    //   this.selectedAppt.date =  moment().toDate();
    //   this.selectedAppt.status = "3";
      
    // }
    
    // this.selectedAppt = {
    //   ...this.selectedAppt,
    //   doctor_partner_type: this.selectedAppt?.training_doctor_partner_type || 'doctor',
    //   viewType: 'editTraining',

    // };
    // this.trainingSwitch = false;
  }

  convertToDateTimeFormat(date: string | Date | null, time?: string) {
    if (!date) return null;

    // Ensure Date object
    const dt = typeof date === 'string' ? new Date(date.replace(/ /g, '-')) : new Date(date);

    // Apply time if provided
    if (time) {
      const [hours, minutes] = time.split(':').map(Number);
      dt.setHours(hours, minutes, 0, 0); // local time
    }

    // Format YYYY-MM-DDTHH:mm:ss
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    const hh = String(dt.getHours()).padStart(2, '0');
    const min = String(dt.getMinutes()).padStart(2, '0');
    const ss = String(dt.getSeconds()).padStart(2, '0');

    return {
      dateTime: `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`,
      timeZone: undefined // no timezone sent
    };
  }
}
